import appName from '../appName';
// client and server can read from this config file. not secure

export default {
  cdn: `//nodes3cdn.hotpads.com/dist/${appName}/`,

  baseApi: 'rental-manager-api/api/v1',
  hotpadsApi: 'api/v2',

  zgApi: {
    development: 'https://localhost:8443',
    production: 'https://rental-manager-api.hotpads.com',
    comet1: 'https://comet1.testpads.net',
    hotpads: 'https://hotpads.com',
  },
  defaultZgApi: 'https://comet1.testpads.net',

  // this should probably be in serverConfig if it uses process.env
  version: process.env.npm_package_version || '0.0.0',

  brands: {
    hotpads: 'hotpads',
    trulia: 'trulia',
    zillow: 'zillow',
  },
  defaultBrand: 'zillow',

  brandUrls: {
    hotpads: 'https://hotpads.com/auth-test',
    trulia: 'https://trulia.com/auth-test',
    zillow: 'https://zillow.com/auth-test',
  },

  supportedBrands: {
    hotpads: true,
    zillow: true,
    trulia: false,
  },

  // todo: reword this, very hotpads specific
  brandHostnames: {
    hotpads: 'https://hotpads.com',
    zillow: 'https://www.zillow.com',
    trulia: 'https://www.trulia.com',
  },
} as const;
